__turbopack_context__.v({
  "grid": "StatsFilters-module__lBJ_Ua__grid",
  "input": "StatsFilters-module__lBJ_Ua__input",
  "interval": "StatsFilters-module__lBJ_Ua__interval",
  "searchIcon": "StatsFilters-module__lBJ_Ua__searchIcon",
  "searchInput": "StatsFilters-module__lBJ_Ua__searchInput",
  "searchWrapper": "StatsFilters-module__lBJ_Ua__searchWrapper",
  "section": "StatsFilters-module__lBJ_Ua__section",
  "select": "StatsFilters-module__lBJ_Ua__select",
});
